const setHue = (r: number, g: number, b: number, max: number, min: number) => {
  let hue = 0;
  const difference: number = max - min;

  if (difference === 0) {
    hue = 0;
  } else if (max === r) {
    const result = 60 * ((g - b) / difference);
    hue = Math.round(result);
  } else if (max === g) {
    const result = 60 * ((b - r) / difference) + 120;
    hue = Math.round(result);
  } else if (max === b) {
    const result = 60 * ((r - g) / difference) + 240;
    hue = Math.round(result);
  }

  if (Math.sign(hue) === -1) {
    hue = hue + 360;
  }

  return hue;
};

const setSaturation = (max: number, min: number) => {
  let saturation = 0;
  const difference: number = max - min;
  if (difference === 0) {
    saturation = 0;
  } else {
    saturation = Math.round(((max - min) / max) * 100);
  }

  return saturation;
};

const setBrightness = (max: number) => {
  const brightness: number = Math.round((max / 255) * 100);

  return brightness;
};

export const rgbToHsb = (r: number, g: number, b: number) => {
  const max: number = Math.max(r, g, b);
  const min: number = Math.min(r, g, b);

  const hue: number = setHue(r, g, b, max, min);
  const saturation: number = setSaturation(max, min);
  const brightness: number = setBrightness(max);

  const hsb: { h: number; s: number; b: number } = {
    h: hue,
    s: saturation,
    b: brightness,
  };

  return hsb;
};

export const hsbToRgb = (h: number, s: number, b: number) => {
  let red = 0;
  let green = 0;
  let blue = 0;
  const max: number = (b / 100) * 255;
  const min: number = Math.round(max - (s / 100) * max);
  const diff: number = max - min;

  if (h >= 0 && h <= 60) {
    red = max;
    green = (h / 60) * diff + min;
    blue = min;
  } else if (h >= 60 && h <= 120) {
    red = ((120 - h) / 60) * diff + min;
    green = max;
    blue = min;
  } else if (h >= 120 && h <= 180) {
    red = min;
    green = max;
    blue = ((h - 120) / 60) * diff + min;
  } else if (h >= 180 && h <= 240) {
    red = min;
    green = ((240 - h) / 60) * diff + min;
    blue = max;
  } else if (h >= 240 && h <= 300) {
    red = ((h - 240) / 60) * diff + min;
    green = min;
    blue = max;
  } else if (h >= 300 && h <= 360) {
    red = max;
    green = min;
    blue = ((360 - h) / 60) * diff + min;
  }

  const rgb: { r: number; g: number; b: number } = {
    r: Math.round(red),
    g: Math.round(green),
    b: Math.round(blue),
  };

  return rgb;
};

export const invertColorByBrightness = (backgroundColor: string): string => {
  if (backgroundColor.match(/^#([A-Fa-f0-9]{6})$/) !== null) {
    const brightness =
      parseInt(backgroundColor.substring(1, 3), 16) * 0.299 +
      parseInt(backgroundColor.substring(3, 5), 16) * 0.587 +
      parseInt(backgroundColor.substring(5, 7), 16) * 0.114;

    return brightness >= 180 ? '#000000' : '#ffffff';
  }

  return backgroundColor;
};
